/**
 * Cart-drawer "Complete their comfort kit" upsell card — behaviour.
 *
 * TICK-BOX (round #22 — replaces the round #18-#21 "Add to my order"
 * button with a small checkbox, at the user's explicit request)
 * ------------------------------------------------------------------
 * Reuses the theme's own existing add-to-cart + Section Rendering API
 * refresh mechanism (the same one assets/product-form.js uses): POST to
 * routes.cart_add_url with `sections` set to whatever <cart-drawer> itself
 * declares it needs (assets/cart-drawer.js#getSectionsToRender), then hand
 * the JSON response straight to <cart-drawer>.renderContents(), which is
 * the theme's own method for swapping in the freshly-rendered drawer HTML
 * (cart items, discount lines, and the estimated total all update from
 * this single response — no separate "show new total" step is needed).
 * No second cart-update pathway is introduced for the add itself.
 *
 * The interaction is now a `change` event on a `<input type="checkbox">`
 * (visually a small tick-box, see snippets/trotwell-order-bump.liquid)
 * instead of a `click` on a `<button>`. Only a checkbox being TICKED
 * triggers the add — a `change` event with `checked === false` is
 * ignored, since there is no "remove from cart" behaviour wired to
 * un-ticking (see below for why that's fine in practice).
 *
 * Because the card is recomputed fresh from the current cart on every
 * render (round #21 — there is no "shown once" cap any more) and a
 * product's own recommendation disappears from the DOM the moment that
 * product is actually in the cart, the checkbox itself is gone from the
 * page by the time a customer could try to un-tick it after a successful
 * add — so there's nothing to reconcile for that case. If the add
 * request fails instead, the checkbox is explicitly unchecked and
 * re-enabled here so it still accurately reflects "not added", and the
 * error message is shown.
 *
 * CHECKOUT
 * --------
 * Is untouched by this file entirely — the drawer's native footer
 * "Check out" button (snippets/cart-drawer.liquid) is a plain form submit
 * with no JS binding here.
 *
 * Because the drawer's HTML is regenerated from Liquid (cart.items) on
 * every refresh, the bump card's eligibility and visibility recompute
 * from scratch server-side each time — there is no client-side state to
 * reconcile at all.
 *
 * A single delegated listener on `document` is used for the checkbox's
 * `change` event instead of binding to the individual checkbox, because
 * the drawer subtree gets replaced wholesale on every refresh (innerHTML
 * swap), which does not preserve listeners bound to the old nodes.
 */
(function () {
  if (window.trotwellOrderBumpInitialized) return;
  window.trotwellOrderBumpInitialized = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionParams(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-trotwell-order-bump-add]');
    if (!checkbox || checkbox.disabled) return;

    // Only a tick triggers the add — there is no un-tick/remove behaviour
    // (see header comment for why that's not needed here).
    if (!checkbox.checked) return;

    var wrapper = checkbox.closest('.trotwell-upsell__checkbox-wrap');
    var cardWrapper = checkbox.closest('[data-trotwell-order-bump]');
    var errorEl = cardWrapper ? cardWrapper.querySelector('[data-trotwell-order-bump-error]') : null;
    var variantId = checkbox.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = getCartDrawer();
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    checkbox.disabled = true;
    if (wrapper) wrapper.classList.add('is-loading');
    var spinner = wrapper ? wrapper.querySelector('.loading__spinner') : null;
    if (spinner) spinner.classList.remove('hidden');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    getSectionParams(cartDrawer).forEach(function (sectionId) {
      formData.append('sections', sectionId);
    });
    formData.append('sections_url', window.location.pathname);

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add this item to your cart.');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'trotwell-order-bump',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          // No <cart-drawer> on the page (e.g. cart_type isn't "drawer") —
          // fall back to the cart page rather than leaving the item added
          // with no visible confirmation.
          window.location.href = cartUrl;
        }
      })
      .catch(function (error) {
        checkbox.disabled = false;
        checkbox.checked = false;
        if (wrapper) wrapper.classList.remove('is-loading');
        if (spinner) spinner.classList.add('hidden');
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = (error && error.message) || 'Something went wrong — please try again.';
        }
      });
  });
})();
